import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cf3d88b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "payList"
}
const _hoisted_2 = {
  key: 1,
  class: "payCont"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "payChange" }
const _hoisted_5 = { class: "pay-service" }
const _hoisted_6 = {
  key: 2,
  class: "wxCode"
}
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "dos" }
const _hoisted_10 = { class: "payListShade" }

import { ref, watch, computed, reactive } from "vue";
import { payPost, payResult } from "@/api/pay";
import Package from "./Package.vue";
import Form from "./Form.vue";
import store from "@/store";
import { ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";
import { PayMentType } from "@/types/pay";
import QrcodeVue from "qrcode.vue";
import i18n from "@/lang";
import WXTips from "./WXTips.vue";
import { val } from "dom7";

export default /*#__PURE__*/_defineComponent({
  __name: 'Pay',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  priceList: {
    type: Array,
    default: [],
  },
  productId: {
    type: Number,
  },
},
  emits: ["update:visible"],
  setup(__props, { emit: emits }) {

const props = __props

const route = useRoute();
const router = useRouter();
const language = computed(() => store.state.appLanguage);
const isMobile = store.state.isMobile;
const payVisible = ref(false);
const priceList = ref([]);
const isWX = ref(false);
const vueCodeQ = reactive({
  isCode: false,
  value: "",
  size: 300,
});

watch(
  () => props.visible,
  () => {
    payVisible.value = props.visible;
  },
  { immediate: true }
);
watch(
  () => props.priceList,
  () => {
    priceList.value = props.priceList;
  }
);
const isDbclick = ref(false);
const formRef = ref(null);
const isWx = reactive({
  isWeixiCode: false,
});
var successCodeTime: any = null;

const getPayMent = (id: String | Number) => {
  if (isDbclick.value) return;
  /**
   * 微信内置浏览器占时处理
   */
  let ua: any = window.navigator.userAgent.toLowerCase();
  if (id === 4) {
    if (
      ua.match(/MicroMessenger/i) == "micromessenger" ||
      ua.match(/_SQ_/i) == "_sq_"
    ) {
      isWX.value = true;
      return false;
    }
  }
  isDbclick.value = true;
  const statisticalType = ref();
  if (
    route.fullPath == "/purchase-services?back_path=privilege" ||
    route.fullPath == "/privilege"
  ) {
    statisticalType.value = "buy";
  } else if (
    route.fullPath == "/purchase-services?back_path=personal" ||
    route.fullPath == "/userCenter/account"
  ) {
    statisticalType.value = "renew";
  }
  const formParams = formRef.value.params;
  const isChecked = formRef.value.isChecked;
  const params: PayMentType = {
    productPriceId: priceList.value
      .find((item) => item.price === formParams.singlePrice)
      ?.id.toString(),
    num: formParams.num,
    payType: id.toString(),
    singlePrice: formParams.singlePrice,
    totalPrice: formParams.totalPrice,
    productId: props.productId,
    orderSource: statisticalType.value,
  };
  if (formParams.vcode && !formParams.type && isChecked) {
    params.vcode = formParams.vcode;
    params.singlePrice = Math.round(params.singlePrice * formParams.discount);
  }
  payPost(params)
    .then((res: any) => {
      if (res.code == 0) {
        if (id == 0 || id == 3) {
          //支付包
          const div = document.createElement("div");
          /* 此处form就是后台返回接收到的数据 */
          div.innerHTML = res.data.body;
          document.body.appendChild(div);
          document.forms[0].submit();
        } else if (id == 1) {
          //微信
          isWx.isWeixiCode = true;
          vueCodeQ.isCode = true;
          vueCodeQ.value = res.data.body;
          clearInterval(Number(successCodeTime));
          successCodeTime = setInterval(() => {
            getSuccessPay(res.data.productOrderNum);
          }, 2000);
        } else if (id === 2) {
          if (isMobile) {
            // window.location.href = res.data.body;
            const a = document.createElement("a");
            a.href = res.data.body;
            a.click();
          } else {
            window.open(res.data.body);
          }
        } else if (id === 4) {
          const BASE_URL = process.env.VUE_APP_BASE_URL;
          const url = encodeURI(
            `${BASE_URL}/pay-ment?out_trade_no=${res.data.productOrderNum}`
          );
          window.location.href = res.data.body + "&redirect_url=" + url;
        }
      }
      isDbclick.value = false;
    })
    .catch(() => {
      isDbclick.value = false;
    });
};
const getSuccessPay = (id: string) => {
  payResult(id).then((res: any) => {
    if (res.data.orderStatus == 1) {
      clearInterval(successCodeTime);
      router.push({
        path: "/pay-ment",
        query: {
          out_trade_no: id,
        },
      });
    }
    if (res.data.orderStatus == 2) {
      ElMessage.error(i18n.global.t("user_center.order_overtime"));
    }
    if (res.data.orderStatus == 3) {
      ElMessage.error(i18n.global.t("user_center.order_error"));
    }
  });
};

const bakcPay = () => {
  isWx.isWeixiCode = false;
  clearInterval(Number(successCodeTime));
};

const closePay = () => {
  payVisible.value = false;
  emits("update:visible", payVisible.value);
  bakcPay();
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (payVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_unref(isMobile))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "javascript:;",
                class: "close",
                onClick: closePay
              }))
            : _createCommentVNode("", true),
          (!isWx.isWeixiCode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (!_unref(isMobile))
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.$t("login.dear_dec_user").replace(
            "nickname",
            _unref(store).state.userInfo.nickName
          )), 1))
                  : _createCommentVNode("", true),
                _createVNode(Package, { "package-list": priceList.value }, null, 8, ["package-list"]),
                _createVNode(Form, {
                  ref_key: "formRef",
                  ref: formRef
                }, null, 512),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("user_center.payment_method")), 1),
                  _createElementVNode("ul", null, [
                    (_unref(language) === 'zh')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("li", {
                            class: "weixin",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (getPayMent(_unref(isMobile) ? 4 : 1)))
                          }),
                          _createElementVNode("li", {
                            class: "zfb",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (getPayMent(_unref(isMobile) ? 3 : 0)))
                          })
                        ], 64))
                      : (_openBlock(), _createElementBlock("li", {
                          key: 1,
                          class: "paypal",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (getPayMent(2)))
                        }))
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_ctx.$t("user_center.purchase_agreement0")), 1),
                    _createVNode(_component_router_link, { to: { path: '/service-clause' } }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("user_center.purchase_agreement1")), 1)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(_toDisplayString(_ctx.$t("user_center.purchase_agreement2")), 1)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "back",
                  onClick: bakcPay
                }),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("user_center.wechat_code_payment")), 1),
                (vueCodeQ.isCode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(QrcodeVue, {
                        value: vueCodeQ.value,
                        size: vueCodeQ.size,
                        level: "H"
                      }, null, 8, ["value", "size"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("user_center.use_r_code")), 1),
                _createElementVNode("div", {
                  class: "bottom",
                  onClick: bakcPay
                }, _toDisplayString(_ctx.$t("user_center.use_other_payment")) + "/" + _toDisplayString(_ctx.$t("user_center.payment_number_text")), 1)
              ]))
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [
      [_vShow, payVisible.value]
    ]),
    (isWX.value)
      ? (_openBlock(), _createBlock(WXTips, {
          key: 1,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (isWX.value = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})